// Initialize userSelection object (if not already defined)
if (typeof userSelection === "undefined") {
  var userSelection = {
    frameType: "Black",  // Default values
    frameSize: "160x80", // Enige beschikbare maat
    frameKey: "Frame_Black_160_16",  // Standaard frame
    frameVariantId: null,  // Wordt ingesteld via getVariantId
    texture: "Ergo",  // Standaard texture voor Ergo tafel
    selectedMonitorBracket: "",  // Default: geen monitorbeugel
    includeKabelgoot: false,  // Default: geen kabelgoot
  };
}

// Variant ID mapping voor Ergo (alleen 160x80 beschikbaar)
const variantMapping = {
  // Frames
  "Frame_Black_160_16_Ergo": "49271691673937",
  "Frame_White_160_15_Ergo": "49271691706705",

  // Monitor brackets
  "Monitor_Bracket_FM-2": "50367644926289",
  "Monitor_Bracket_FM-1": "50452896678225",
  "Monitor_Bracket_SQ-2": "50452901200209",
  "Monitor_Bracket_Monitor_bracket_fm1_18": "50452896678225",
  "Monitor_Bracket_DXM-002_19": "50643150537041",
  "Monitor_Bracket_DXM-003_20": "50643153060177",
  "Monitor_Bracket_DXM-004_21": "50643159253329",
  "Monitor_Bracket_DXM-001_22": "50643167740241",
  "Monitor_Bracket_SH-X6_23": "50643170099537",
  "Monitor_Bracket_SH-X7_25": "50643172131153",
  "Monitor_Bracket_SH-AMSP-02_24": "50643174621521",

  // Kabelgoot
  "Kabelgoot": "50452855095633",
};

// Functie om de Variant ID op te halen
function getVariantId(frameKey, texture) {
  const variantKey = `${frameKey}_${texture}`;
  console.log(`Getting variant ID for: ${variantKey}`);
  return variantMapping[variantKey];
}

// Update userSelection op basis van de frame kleur dropdown (id: frameColorDropdown)
document.getElementById("frameColorDropdown").addEventListener("change", (e) => {
  const selectedFrame = e.target.value;
  if (selectedFrame === "Frame_Black_160_16") {
    userSelection.frameType = "Black";
  } else {
    userSelection.frameType = "White";
  }
  userSelection.frameKey = selectedFrame;
  userSelection.frameVariantId = getVariantId(userSelection.frameKey, userSelection.texture);
  console.log(`Updated frame selection: ${JSON.stringify(userSelection)}`);
});

// Update userSelection bij textuurslectie via de Ergo-knop (id: ergoTopButton)
document.getElementById("ergoTopButton").addEventListener("click", () => {
  userSelection.texture = "Ergo";
  userSelection.frameVariantId = getVariantId(userSelection.frameKey, userSelection.texture);
  console.log(`Texture changed to Ergo: ${JSON.stringify(userSelection)}`);
});

// Monitorbeugel dropdown (custom dropdown die de waarde direct toewijst)
document.getElementById("monitorBracketDropdown").addEventListener("change", (e) => {
  userSelection.selectedMonitorBracket = e.target.value; // Verwachte waarden: "FM-2", "FM-1", "SQ-2", "DXM-002", "DXM-003", "DXM-004", "DXM-001", "SH-X6", "SH-X7", "SH-AMSP-02"
  console.log(`Selected Monitor Bracket: ${userSelection.selectedMonitorBracket}`);
});

// Kabelgoot toggle
document.getElementById("cableTrayCheckbox").addEventListener("change", (e) => {
  userSelection.includeKabelgoot = e.target.checked;
  console.log(`Kabelgoot Included: ${e.target.checked}`);
});

// Add to Cart knop logica met foutafhandeling
document.getElementById("add-to-cart-button").addEventListener("click", async function () {
  if (!userSelection.frameVariantId) {
    alert("Selecteer een frame en ga door met bestellen.");
    return;
  }

  const quantityInput = document.getElementById("quantityInput");
  const quantity = parseInt(quantityInput.value);

  if (isNaN(quantity) || quantity < 1) {
    alert("Voer een geldige hoeveelheid in.");
    return;
  }

  const items = [
    {
      id: userSelection.frameVariantId,
      quantity: quantity,
    },
  ];

  // Voeg monitorbeugel toe als er een is geselecteerd
  if (userSelection.selectedMonitorBracket) {
    const monitorBracketKey = `Monitor_Bracket_${userSelection.selectedMonitorBracket}`;
    if (variantMapping[monitorBracketKey]) {
      items.push({
        id: variantMapping[monitorBracketKey],
        quantity: 1,
      });
    } else {
      console.warn(`Monitor bracket key "${monitorBracketKey}" niet gevonden in variantMapping.`);
    }
  }

  // Voeg Kabelgoot toe als geselecteerd
  if (userSelection.includeKabelgoot) {
    items.push({ id: variantMapping["Kabelgoot"], quantity: 1 });
  }

  console.log("Adding to cart:", items);

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });

    if (!response.ok) throw new Error("Error adding items to cart");

    window.location.href = "/cart";
  } catch (error) {
    console.error("Error adding to cart:", error);
    alert("Er is een fout opgetreden bij het toevoegen van de items aan de winkelwagen.");
  }
});

// Initialiseer de standaard cart setup
console.log("Cart setup initialized.");
